import React, { useEffect } from "react";
import FormInput from "../FormInput/FormInput";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { EmptyingAllInputs, Notification } from "../../utils";
import { clearErrors } from "../../redux/actions/userActions";
import Loader from "../Loader/Loader";
import { useNavigate } from "react-router-dom";

const SingleInputAuth = ({
  tag,
  type,
  name,
  placeholder,
  actionFunction,
  userEmail,
}) => {
  const navigate=useNavigate()
  console.log("this is userEmail", userEmail);
  const { error, loading, response, success ,isAuthenticated} = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();

  const schema = yup.object().shape({
    [name]: yup.string().required("Please enter your OTP here"),
  });

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue(name, value, { shouldValidate: true });
  };

  const onSubmit = (data) => {
    if (name === "otp") {
      const updatedData = {
        ...data,
        email: userEmail,
      };
      dispatch(actionFunction(updatedData));
    }
    reset();
    EmptyingAllInputs();
    console.log("data form Single ", data);
  };

  useEffect(() => {
    if (success) {
      Notification(success, error, "Otp verified successfully");
    } else {
      Notification(success, error, response);
    }

    if(isAuthenticated){
      navigate("/user/new-surveys") 
    }
    dispatch(clearErrors());
  }, [dispatch, error, loading, response, success,isAuthenticated]);

  return (
    <>
      <div className="dg__account mt-5">
        <div className="container">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-12">
                <FormInput
                  tag={tag}
                  type={type}
                  name={name}
                  placeholder={placeholder}
                  register={register}
                  error={errors[name]}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <div className="contact-btn">
                  <button type="submit">
                    {loading ? <Loader /> : "Submit"}
                    <span className="ti-arrow-right" />
                  </button>
                </div>

                <div className="form-message" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SingleInputAuth;
